module.exports = __webpack_public_path__ + "img/present-2x.bb9fa57f.png";